module.exports = __webpack_public_path__ + "static/media/vscode.9ef30e12.svg";